/* eslint-disable camelcase */
type Locale = 'en' | 'es';
interface Vars {
  percentage: string | number;
}
type Phrase = (l: Locale, v: Vars) => string;

export const i18n_save_x_percent: Phrase = (locale, { percentage }) => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Save ${percentage}%`,
    es: `Ahorra ${percentage}%`,
  };
  return phrases[locale] || phrases.en || ``;
};
